import React from 'react';
import Navbar from '../components/Navbar';
import HistoricoMovimientos from '../components/HistoricoComponents/HistoricoMovimientos';

const HistoricoMovimientosPage = () => {
  return (
    <div>
      <Navbar />
      <HistoricoMovimientos />
    </div>
  );
};

export default HistoricoMovimientosPage;